module.exports = __webpack_public_path__ + "img/slogan.cd2115d2.png";